module.exports = __webpack_public_path__ + "media/images/avatar_male5-00477d6af4a75065788b46be6368422a.png";